import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IBank } from "@/interfaces/talk2pay.iterfaces";
import t2payService from "@/services/t2pay.service";
import { PaginatedResponse, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<PaginatedResponse<IBank> | null>;

type GetAllSwrParams = [string, number, number];

const pageNumber = 1;
const pageSize = 10000;

const useGetBanks = (): Return => {
  const fetcher = useSWR<PaginatedResponse<IBank>, Error, GetAllSwrParams>(
    [SWR_KEYS.getBanks, pageNumber, pageSize],
    ([, _pageNumber, _pageSize]) =>
      t2payService.getBanks({ pageNumber: _pageNumber, pageSize: _pageSize }),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetBanks;
